// extracted by mini-css-extract-plugin
module.exports = {"root":"Startup_root__yvepI","content":"Startup_content__vhzf0","title":"Startup_title__aTq4H","subtitle":"Startup_subtitle__S8BWP","feature":"Startup_feature__P0R__"};